import React, { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

import AddIcon from "@mui/icons-material/Add";
import Medusa from "services/api";
import CreateUserModal from "pages/admin/users/components/CreateUserModal";

//import InviteModal from "../../../components/organisms/invite-modal"
//import CreateUserModal from "@/components/upstyled/create-user-modal"

import UserTable from "pages/admin/users/components/UserTable";
import Actionables from "components/UpStyled/Actionables";

import toast from "react-hot-toast";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [invites, setInvites] = useState([]);
  const [shouldRefetch, setShouldRefetch] = useState(0);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const triggerRefetch = () => {
    setShouldRefetch((prev) => prev + 1);
  };

  useEffect(() => {
    Medusa.users
      .list()
      .then((res) => {
        const userData = res?.data || {};
        console.log(userData);
        setUsers(userData?.users || []);
        Medusa.invites
          .list()
          .then((res) => {
            const inviteData = res?.data || {};
            setInvites(inviteData?.invites || []);
          })
          .catch((err) => toast.error(err.message));
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
      });
  }, [shouldRefetch]);

  const actions = [
    /*
    {
      label: "Invite Users",
      onClick: () => setShowInviteModal(true),
      icon: <AddIcon fontSize={"small"} />,
    },*/
    {
      label: "Create New User",
      onClick: () => setShowCreateModal(true),
      icon: <AddIcon fontSize={"small"} />,
    },
  ];

  return (
    <Card id="company-info" sx={{ overflow: "visible" }} className="my-2">
      <SuiBox p={3}>
        <SuiTypography variant="h5">Users</SuiTypography>
      </SuiBox>
      <div className="flex justify-between	">
        <SuiBox px={3}>
          <SuiTypography variant="h6">Management all users of UpStyled platform</SuiTypography>
        </SuiBox>
        <Actionables actions={actions} />
      </div>
      <div className="flex grow  flex-col pt-2">
        <UserTable users={users} invites={invites} triggerRefetch={triggerRefetch} />
      </div>
      <div className="inter-small-regular text-gray-500 ml-4 mb-2">
        {users.length} Members
        {users.length === 1 ? "" : "s"}
      </div>
      {/**
          {showInviteModal && (
            <InviteModal
              handleClose={() => {
                triggerRefetch()
                setShowInviteModal(false)
              }}
            />
          )}
           */}
      {showCreateModal && (
        <CreateUserModal
          visible={showCreateModal}
          handleClose={() => {
            triggerRefetch();
            setShowCreateModal(false);
          }}
        />
      )}
    </Card>
  );
};

export default Users;
